// ISO2 country code -> { el, en, dial }
export const COUNTRY_NAMES = {
  GR: { el: "Ελλάδα", en: "Greece", dial: "+30" },
  DE: { el: "Γερμανία", en: "Germany", dial: "+49" },
  FR: { el: "Γαλλία", en: "France", dial: "+33" },
  IT: { el: "Ιταλία", en: "Italy", dial: "+39" },
  ES: { el: "Ισπανία", en: "Spain", dial: "+34" },
  PT: { el: "Πορτογαλία", en: "Portugal", dial: "+351" },
  GB: { el: "Ηνωμένο Βασίλειο", en: "United Kingdom", dial: "+44" },
  IE: { el: "Ιρλανδία", en: "Ireland", dial: "+353" },
  NL: { el: "Ολλανδία", en: "Netherlands", dial: "+31" },
  BE: { el: "Βέλγιο", en: "Belgium", dial: "+32" },
  LU: { el: "Λουξεμβούργο", en: "Luxembourg", dial: "+352" },
  CH: { el: "Ελβετία", en: "Switzerland", dial: "+41" },
  AT: { el: "Αυστρία", en: "Austria", dial: "+43" },
  PL: { el: "Πολωνία", en: "Poland", dial: "+48" },
  CZ: { el: "Τσεχία", en: "Czechia", dial: "+420" },
  SK: { el: "Σλοβακία", en: "Slovakia", dial: "+421" },
  HU: { el: "Ουγγαρία", en: "Hungary", dial: "+36" },
  RO: { el: "Ρουμανία", en: "Romania", dial: "+40" },
  BG: { el: "Βουλγαρία", en: "Bulgaria", dial: "+359" },
  HR: { el: "Κροατία", en: "Croatia", dial: "+385" },
  SI: { el: "Σλοβενία", en: "Slovenia", dial: "+386" },
  RS: { el: "Σερβία", en: "Serbia", dial: "+381" },
  AL: { el: "Αλβανία", en: "Albania", dial: "+355" },
  MK: { el: "Βόρεια Μακεδονία", en: "North Macedonia", dial: "+389" },
  TR: { el: "Τουρκία", en: "Turkey", dial: "+90" },
  CY: { el: "Κύπρος", en: "Cyprus", dial: "+357" },
  MT: { el: "Μάλτα", en: "Malta", dial: "+356" },
  SE: { el: "Σουηδία", en: "Sweden", dial: "+46" },
  NO: { el: "Νορβηγία", en: "Norway", dial: "+47" },
  DK: { el: "Δανία", en: "Denmark", dial: "+45" },
  FI: { el: "Φινλανδία", en: "Finland", dial: "+358" },
  IS: { el: "Ισλανδία", en: "Iceland", dial: "+354" },
  EE: { el: "Εσθονία", en: "Estonia", dial: "+372" },
  LV: { el: "Λετονία", en: "Latvia", dial: "+371" },
  LT: { el: "Λιθουανία", en: "Lithuania", dial: "+370" },
  US: { el: "ΗΠΑ", en: "United States", dial: "+1" },
  CA: { el: "Καναδάς", en: "Canada", dial: "+1" },
  MX: { el: "Μεξικό", en: "Mexico", dial: "+52" },
  BR: { el: "Βραζιλία", en: "Brazil", dial: "+55" },
  AR: { el: "Αργεντινή", en: "Argentina", dial: "+54" },
  AU: { el: "Αυστραλία", en: "Australia", dial: "+61" },
  NZ: { el: "Νέα Ζηλανδία", en: "New Zealand", dial: "+64" },
  JP: { el: "Ιαπωνία", en: "Japan", dial: "+81" },
  CN: { el: "Κίνα", en: "China", dial: "+86" },
  KR: { el: "Νότια Κορέα", en: "South Korea", dial: "+82" },
  IN: { el: "Ινδία", en: "India", dial: "+91" },
  SG: { el: "Σιγκαπούρη", en: "Singapore", dial: "+65" },
  HK: { el: "Χονγκ Κονγκ", en: "Hong Kong", dial: "+852" },
  TW: { el: "Ταϊβάν", en: "Taiwan", dial: "+886" },
  AE: { el: "ΗΑΕ", en: "UAE", dial: "+971" },
  SA: { el: "Σαουδική Αραβία", en: "Saudi Arabia", dial: "+966" },
  IL: { el: "Ισραήλ", en: "Israel", dial: "+972" },
  EG: { el: "Αίγυπτος", en: "Egypt", dial: "+20" },
  ZA: { el: "Νότια Αφρική", en: "South Africa", dial: "+27" },
  MA: { el: "Μαρόκο", en: "Morocco", dial: "+212" },
  RU: { el: "Ρωσία", en: "Russia", dial: "+7" },
  UA: { el: "Ουκρανία", en: "Ukraine", dial: "+380" },
};

// English country name -> ISO2 code (for back-translating data stored in English)
export const COUNTRY_NAME_TO_CODE = {
  "Germany": "DE", "France": "FR", "Italy": "IT", "Spain": "ES", "Portugal": "PT",
  "United Kingdom": "GB", "UK": "GB", "Ireland": "IE", "Netherlands": "NL", "Belgium": "BE",
  "Luxembourg": "LU", "Switzerland": "CH", "Austria": "AT", "Poland": "PL", "Czechia": "CZ",
  "Czech Republic": "CZ", "Slovakia": "SK", "Hungary": "HU", "Romania": "RO", "Bulgaria": "BG",
  "Croatia": "HR", "Slovenia": "SI", "Serbia": "RS", "Albania": "AL", "North Macedonia": "MK",
  "Turkey": "TR", "Cyprus": "CY", "Malta": "MT", "Sweden": "SE", "Norway": "NO",
  "Denmark": "DK", "Finland": "FI", "Iceland": "IS", "Estonia": "EE", "Latvia": "LV",
  "Lithuania": "LT", "United States": "US", "USA": "US", "Canada": "CA", "Mexico": "MX",
  "Brazil": "BR", "Argentina": "AR", "Australia": "AU", "New Zealand": "NZ", "Japan": "JP",
  "China": "CN", "South Korea": "KR", "India": "IN", "Singapore": "SG", "Hong Kong": "HK",
  "Taiwan": "TW", "UAE": "AE", "United Arab Emirates": "AE", "Saudi Arabia": "SA",
  "Israel": "IL", "Egypt": "EG", "South Africa": "ZA", "Morocco": "MA", "Russia": "RU",
  "Ukraine": "UA", "Greece": "GR",
};

export function countryLabel(country, countryCode, lang) {
  const code = (countryCode || COUNTRY_NAME_TO_CODE[country] || "").toUpperCase();
  const entry = COUNTRY_NAMES[code];
  if (entry) return entry[lang] || entry.en || country;
  return country;
}

export function flagFromCode(code) {
  if (!code || code.length !== 2) return "🌍";
  const cc = code.toUpperCase();
  return String.fromCodePoint(...[...cc].map((c) => 127397 + c.charCodeAt(0)));
}

export function dialCodeFor(code) {
  const entry = COUNTRY_NAMES[(code || "").toUpperCase()];
  return entry?.dial || "";
}

// Sorted list of (code, label, dial) for select dropdowns
export function getCountryOptions(lang = "el") {
  return Object.entries(COUNTRY_NAMES)
    .map(([code, info]) => ({
      code, dial: info.dial,
      label: info[lang] || info.en,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, lang === "el" ? "el" : "en"));
}
